module.exports = (app) => {
  require('@feature/citi-redirects').radio(app);
  require('./my-account').default(app);
  require('./one-time-payment')(app);
  require('./acct-compl-overlay')(app);
  require('./smart-prompt')(app);
  require('./credit-gateway')(app);
  require('./amex-offers')(app);
  require('./tealium-scripts-async')(app);
};
